import styled, { css } from 'styled-components';
import { getSchemaState } from '../../../foundation/theme/palette.utils';
import { getSpace } from '../../../foundation/theme/space.utils';
import { BADGE_PADDING_SIZES } from './Badge.constants';
// styled-components.
// -----------------------------------------------------------------------------
export const BadgeRoot = styled.span `
  ${({ isClickable, isRounded, isLoading, size, ...args }) => {
    const { background, border, foreground, active, foregroundAlt } = getSchemaState({
        ...args,
        state: 'default'
    });
    const verticalPadding = getSpace(BADGE_PADDING_SIZES[size].vertical);
    const horizontalPadding = isRounded
        ? verticalPadding
        : getSpace(BADGE_PADDING_SIZES[size].horizontal);
    return css `
      /* Fixed rules */
      align-items: center;
      border-radius: 100px;
      display: inline-flex;
      align-items: center;
      gap: ${getSpace(BADGE_PADDING_SIZES[size].gap)};
      justify-content: center;
      text-align: center;

      /* Clickable */
      ${isClickable && `cursor: pointer;`}

      ${isClickable && !isLoading && `&:hover { background-color: ${active}; }`}

      /* Colors */
      background-color: ${background};
      border: 2px solid ${border};
      color: ${foreground};

      /* Paddings */
      padding-bottom: ${verticalPadding};
      padding-left: ${horizontalPadding};
      padding-top: ${verticalPadding};
      padding-right: ${horizontalPadding};

      /* Icon */
      svg {
        color: ${foregroundAlt};
      }

      /* isLoading */
      ${isLoading &&
        css `
        pointer-events: none;

        .button__icon--loading svg {
          color: ${active || foregroundAlt};
        }
      `}

      /* Close button. */
      .close-button,
      .close-button:hover {
        background: none;
        border: none;
        padding: 0;
      }
    `;
}}
`;
export const BadgeText = styled.span `
  white-space: nowrap;
  margin-top: ${({ size }) => (size === 'xs' ? '-2px' : '0')};
`;
//# sourceMappingURL=Badge.styled.js.map